<template>
    <div >
        <h1 style="font-size: 24px; color: black;">活动奖品概况</h1>
        <el-row >
            <el-col :span="3">
                <div class="out-border">
                    <div class="layout-title">周抽活动奖品统计</div>
                    <div class="color-main address-content">
                        <el-link type="primary" href="#/weekActivitySummary">查看<i class="el-icon-view el-icon--right"></i> </el-link>
                    </div>
                </div>
            </el-col>
            <el-col :span="3">
                <div class="out-border">
                    <div class="layout-title">碎片活动奖品统计</div>
                    <div class="color-main address-content">
                        <el-link type="primary" href="#/pieceActivitySummary">查看<i class="el-icon-view el-icon--right"></i> </el-link>
                    </div>
                </div>
            </el-col>
            <el-col :span="3">
                <div class="out-border">
                    <div class="layout-title">签到活动奖品统计</div>
                    <div class="color-main address-content">
                        <el-link type="primary">查看<i class="el-icon-view el-icon--right"></i> </el-link>
                    </div>
                </div>
            </el-col>
        </el-row>
        <div class="total-layout">
            <el-row :gutter="20">
                <el-col :span="4">
                    <div class="total-frame">
                        <div class="top-item">
                            <div>
                                <img :src="img_home_address" class="total-icon">
                            </div>
                            <div class="total-title">奖品发放明细</div>
                        </div>
                        <div class="total-value">
                            <el-link type="primary" href="#/prizeReport">查看<i class="el-icon-view el-icon--right"></i> </el-link>
                        </div>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="total-frame">
                        <div class="top-item">
                            <div>
                                <img :src="img_home_address" class="total-icon">
                            </div>
                            <div class="total-title">中奖发货明细</div>
                        </div>
                        <div class="total-value">
                            <el-link type="primary" href="#/sendList">查看<i class="el-icon-view el-icon--right"></i> </el-link>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>

</template>

<script>
    import img_home_address from '@/assets/home_address.png';
    export default {
        name: "ActivitySummary",
        data() {
            return {
                img_home_address,
            }
        },
        methods:{
        },
        created() {
        }
    }
</script>

<style scoped>
    .out-border {
        border: 1px solid #DCDFE6;
    }

    .layout-title {
        color: #606266;
        padding: 15px 20px;
        background: #F2F6FC;
        font-weight: bold;
        font-size: 18px;
    }

    .address-content{
        padding: 20px;
        font-size: 20px
    }

    .color-main {
        color: #409EFF;
    }

    .total-frame {
        border: 1px solid #DCDFE6;
        padding: 20px;
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-content: center;
        justify-content: center;
        align-items: center;
    }

    .total-layout {
        margin-top: 20px;
    }

    .total-value {
        position: relative;
        font-size: 18px;
        color: #606266;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        width: 100%;
    }

    .total-icon {
        color: #409EFF;
        width: 60px;
        height: 60px;
    }

    .total-title {
        position: relative;
        font-size: 16px;
        color: #909399;
    }
    .top-item{
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-content: center;
        justify-content: space-between;
        align-items: center;
        width: 100%;
    }

</style>
